import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
export const serviceApi = createApi({
  reducerPath: "reqres/service",
  tagTypes: ["service"],
  baseQuery: fetchBaseQuery({
    baseUrl: "https://statservice.vercel.app/",
  }),
  endpoints: (build) => ({
    getIp: build.mutation({
      query: (body) => ({
        url: `info`,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "service", id: "LIST" }],
    }),
  }),
});

export const { useGetIpMutation } = serviceApi;
